export default __webpack_public_path__ + "static/media/automated.bba42db5.png";